const GARAGE_GETTERS = {
  getGarages: state => state.garages,
  getGarageSearchResults: state => state.garageSearchResults,
  getTireCodes: state => state.tireCodes,
  getError: state => state.status.error,
};

export default GARAGE_GETTERS;
